import { Row } from "@tento-ui/component-builtin";
import { Button } from "@tento-ui/components/button/button";
import { Storybook } from "@tento-ui/ui/storybook";
import { TaskPriorityIndicator } from "./task-priority-indicator";
import { TaskStorybook } from "./task-storybook-helpers";

export class TaskPriorityIndicatorStoryBook extends Storybook.Default {
  title(): string {
    return "Task Priority Indicator";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Priority Levels",
        render: () => {
          const $noPriority = TaskPriorityIndicator.make();
          $noPriority.bind(null);

          const $low = TaskPriorityIndicator.make();
          $low.bind("low");

          const $medium = TaskPriorityIndicator.make();
          $medium.bind("medium");

          const $high = TaskPriorityIndicator.make();
          $high.bind("high");

          return TaskStorybook.createIndicatorGrid({
            items: [
              {
                $indicator: $noPriority,
                label: "No Priority",
              },
              {
                $indicator: $low,
                label: "Low",
              },
              {
                $indicator: $medium,
                label: "Medium",
              },
              {
                $indicator: $high,
                label: "High",
              },
            ],
          });
        },
      },
      {
        title: "Interactive Example",
        render: () => {
          const priorities: Array<Option<"high" | "medium" | "low">> = [
            null,
            "low",
            "medium",
            "high",
          ];
          let currentIndex = 0;

          const $container = Row.make();
          $container.style.alignItems = "center";
          $container.style.gap = "16px";
          $container.style.flexWrap = "wrap";

          const $indicator = TaskPriorityIndicator.make();
          $indicator.bind(priorities[currentIndex]);
          $indicator.style.background = "var(--bg-hover)";
          $indicator.style.borderRadius = "4px";
          $indicator.style.flexShrink = "0";

          const $button = Button.makeWith("Cycle Priority", {
            type: "secondary",
            onClick: () => {
              currentIndex = (currentIndex + 1) % priorities.length;
              $indicator.bind(priorities[currentIndex]);
            },
          });

          $container.appendChild($indicator);
          $container.appendChild($button);

          return $container;
        },
      },
    ];
  }
}
